import { FormikErrors, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";

interface ICompanyNameProps {
  companyName: string;
  // errors: FormikErrors<IRequestCashReq>;
  // touched: any;
  handleChange: React.ChangeEventHandler<HTMLInputElement>;
}

// 통합 이용약관, 개인정보처리방침 동의
const CompanyName = ({ handleChange }: ICompanyNameProps) => {
  const { isOciProduct } = useIsOciProduct();
  const { errors, touched, setFieldValue, values } = useFormikContext<any>();
  const { t } = useTranslation();
  return (
    <div className="form-item">
      {isOciProduct &&
        window.sessionStorage.getItem("product") === "WRAPSODY" && (
          <Form.Group className="mb-3">
            <Form.Label>{t("logIn.signUp.companyName")}</Form.Label>
            <Form.Control
              type="text"
              name="companyName"
              // ref={companyNameRef}
              onChange={handleChange}
              maxLength={256}
              placeholder={t("logIn.signUp.companyName")}
              className={"custom-form"}
              isInvalid={!!errors.companyName && !!touched.companyName}
            />
            <Form.Control.Feedback type="invalid">
              <>{errors?.companyName}</>
            </Form.Control.Feedback>
          </Form.Group>
        )}
    </div>
  );
};

export default CompanyName;
